import { render, staticRenderFns } from "./stepTem.vue?vue&type=template&id=86666ac8&scoped=true"
import script from "./stepTem.vue?vue&type=script&lang=js"
export * from "./stepTem.vue?vue&type=script&lang=js"
import style0 from "./stepTem.vue?vue&type=style&index=0&id=86666ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86666ac8",
  null
  
)

export default component.exports